module.exports = __webpack_public_path__ + "static/media/login.e2df86af.png";